export default __webpack_public_path__ + "static/media/header.d2dbf5ef.png";